<template>
    <div
        class="modal fade slide-in-top"
        id="shareByDots"
        tabindex="-1"
        aria-labelledby="shareByDots"
        aria-hidden="true"
    >
        <div class="modal-dialog modal-sm-down">
            <div class="modal-content">
                <div class="modal-header" style="justify-content: center">
                    <div class="" style="justify-content: center">
                        <h2 class="modal-title font-[700]" id="shareByDots">
                            Share this Allmyonline
                        </h2>
                    </div>
                    <button
                        type="button"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        style="position: absolute; right: 32px"
                    >
                        <svg
                            class=""
                            width="16px"
                            height="16px"
                            viewBox="-0.5 0 25 25"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <g id="SVGRepo_bgCarrier" stroke-width="0"></g>
                            <g
                                id="SVGRepo_tracerCarrier"
                                stroke-linecap="round"
                                stroke-linejoin="round"
                            ></g>
                            <g id="SVGRepo_iconCarrier">
                                <path
                                    d="M3 21.32L21 3.32001"
                                    stroke="#808080"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                ></path>
                                <path
                                    d="M3 3.32001L21 21.32"
                                    stroke="#808080"
                                    stroke-width="1.5"
                                    stroke-linecap="round"
                                    stroke-linejoin="round"
                                ></path>
                            </g>
                        </svg>
                    </button>
                </div>
                <div class="modal-body">
                    <share-by-social-icons :appUrl="appUrl" :user="user" />
                    <share-by-qr :value="appUrl" :user="user" />
                </div>
                <div class="modal-body m-auto d-none">
                    <div class="row m-auto text-center">
                        <div class="col-lg-3 m-auto">
                            <button
                                data-bs-toggle="modal"
                                data-bs-target="#shareByQr"
                                class="btn buzz-out-on-hover p-4"
                                style="color: rgb(103 107 95)"
                            >
                                <svg
                                    width="7em"
                                    fill="#000000"
                                    viewBox="0 0 36 36"
                                    version="1.1"
                                    preserveAspectRatio="xMidYMid meet"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                >
                                    <g
                                        id="SVGRepo_bgCarrier"
                                        stroke-width="0"
                                    ></g>
                                    <g
                                        id="SVGRepo_tracerCarrier"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    ></g>
                                    <g id="SVGRepo_iconCarrier">
                                        <title>qr-code-line</title>
                                        <path
                                            d="M5.6,4A1.6,1.6,0,0,0,4,5.6V12h8V4ZM10,10H6V6h4Z"
                                            class="clr-i-outline clr-i-outline-path-1"
                                        ></path>
                                        <path
                                            d="M4,30.4A1.6,1.6,0,0,0,5.6,32H12V24H4ZM6,26h4v4H6Z"
                                            class="clr-i-outline clr-i-outline-path-2"
                                        ></path>
                                        <path
                                            d="M24,32h6.4A1.6,1.6,0,0,0,32,30.4V24H24Zm2-6h4v4H26Z"
                                            class="clr-i-outline clr-i-outline-path-3"
                                        ></path>
                                        <path
                                            d="M30.4,4H24v8h8V5.6A1.6,1.6,0,0,0,30.4,4ZM30,10H26V6h4Z"
                                            class="clr-i-outline clr-i-outline-path-4"
                                        ></path>
                                        <polygon
                                            points="20 10 20 8 16 8 16 12 18 12 18 10 20 10"
                                            class="clr-i-outline clr-i-outline-path-5"
                                        ></polygon>
                                        <rect
                                            x="12"
                                            y="12"
                                            width="2"
                                            height="2"
                                            class="clr-i-outline clr-i-outline-path-6"
                                        ></rect>
                                        <rect
                                            x="14"
                                            y="14"
                                            width="4"
                                            height="2"
                                            class="clr-i-outline clr-i-outline-path-7"
                                        ></rect>
                                        <polygon
                                            points="20 6 20 8 22 8 22 4 14 4 14 8 16 8 16 6 20 6"
                                            class="clr-i-outline clr-i-outline-path-8"
                                        ></polygon>
                                        <rect
                                            x="4"
                                            y="14"
                                            width="2"
                                            height="4"
                                            class="clr-i-outline clr-i-outline-path-9"
                                        ></rect>
                                        <polygon
                                            points="12 16 12 18 10 18 10 14 8 14 8 18 6 18 6 20 4 20 4 22 8 22 8 20 10 20 10 22 12 22 12 20 14 20 14 16 12 16"
                                            class="clr-i-outline clr-i-outline-path-10"
                                        ></polygon>
                                        <polygon
                                            points="20 16 22 16 22 18 24 18 24 16 26 16 26 14 22 14 22 10 20 10 20 12 18 12 18 14 20 14 20 16"
                                            class="clr-i-outline clr-i-outline-path-11"
                                        ></polygon>
                                        <polygon
                                            points="18 30 14 30 14 32 22 32 22 30 20 30 20 28 18 28 18 30"
                                            class="clr-i-outline clr-i-outline-path-12"
                                        ></polygon>
                                        <polygon
                                            points="22 20 22 18 20 18 20 16 18 16 18 18 16 18 16 20 18 20 18 22 20 22 20 20 22 20"
                                            class="clr-i-outline clr-i-outline-path-13"
                                        ></polygon>
                                        <rect
                                            x="30"
                                            y="20"
                                            width="2"
                                            height="2"
                                            class="clr-i-outline clr-i-outline-path-14"
                                        ></rect>
                                        <rect
                                            x="22"
                                            y="20"
                                            width="6"
                                            height="2"
                                            class="clr-i-outline clr-i-outline-path-15"
                                        ></rect>
                                        <polygon
                                            points="30 14 28 14 28 16 26 16 26 18 28 18 28 20 30 20 30 18 32 18 32 16 30 16 30 14"
                                            class="clr-i-outline clr-i-outline-path-16"
                                        ></polygon>
                                        <rect
                                            x="20"
                                            y="22"
                                            width="2"
                                            height="6"
                                            class="clr-i-outline clr-i-outline-path-17"
                                        ></rect>
                                        <polygon
                                            points="14 28 16 28 16 26 18 26 18 24 16 24 16 20 14 20 14 28"
                                            class="clr-i-outline clr-i-outline-path-18"
                                        ></polygon>
                                        <rect
                                            x="0"
                                            y="0"
                                            width="36"
                                            height="36"
                                            fill-opacity="0"
                                        ></rect>
                                    </g>
                                </svg>
                                <!--                                <span>QR</span>-->
                            </button>
                        </div>
                        <div class="col-lg-3 m-auto">
                            <button
                                data-bs-toggle="modal"
                                data-bs-target="#shareBySms"
                                class="btn p-4 buzz-out-on-hover"
                                style="color: rgb(103 107 95)"
                            >
                                <svg
                                    width="7em"
                                    fill="#000000"
                                    version="1.1"
                                    id="Icon"
                                    xmlns="http://www.w3.org/2000/svg"
                                    xmlns:xlink="http://www.w3.org/1999/xlink"
                                    viewBox="0 0 24 24"
                                    enable-background="new 0 0 24 24"
                                    xml:space="preserve"
                                >
                                    <g
                                        id="SVGRepo_bgCarrier"
                                        stroke-width="0"
                                    ></g>
                                    <g
                                        id="SVGRepo_tracerCarrier"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    ></g>
                                    <g id="SVGRepo_iconCarrier">
                                        <path
                                            d="M12,1C5.37,1,0,5.58,0,10.55c0,2.92,1.86,5.95,4.72,7.59L3,23l5.85-3.32C9.86,19.88,10.91,20,12,20c6.63,0,12-4.48,12-9.45 C24,5.58,18.63,1,12,1z M6.55,13.8c-0.53,0.47-1.24,0.7-2.14,0.7c-0.52,0-0.97-0.06-1.36-0.17c-0.39-0.11-0.75-0.26-1.09-0.43v-1.84 h0.16c0.34,0.33,0.71,0.58,1.12,0.76c0.41,0.18,0.8,0.26,1.19,0.26c0.1,0,0.23-0.01,0.38-0.04c0.16-0.02,0.29-0.06,0.38-0.11 c0.12-0.06,0.22-0.14,0.3-0.25c0.08-0.1,0.12-0.24,0.12-0.42c0-0.19-0.07-0.35-0.2-0.47s-0.29-0.21-0.48-0.26 c-0.23-0.07-0.47-0.13-0.73-0.2c-0.26-0.06-0.51-0.14-0.73-0.23c-0.52-0.21-0.9-0.49-1.12-0.85c-0.23-0.36-0.34-0.8-0.34-1.34 c0-0.72,0.27-1.31,0.8-1.75c0.53-0.45,1.2-0.67,2-0.67c0.4,0,0.8,0.05,1.2,0.14c0.4,0.09,0.75,0.22,1.06,0.38v1.76H6.93 C6.68,8.54,6.37,8.33,6.01,8.16C5.65,7.99,5.28,7.9,4.9,7.9c-0.15,0-0.28,0.01-0.4,0.04C4.38,7.97,4.26,8.01,4.13,8.08 c-0.11,0.06-0.2,0.14-0.27,0.25C3.78,8.44,3.74,8.56,3.74,8.69c0,0.2,0.06,0.35,0.18,0.47c0.12,0.12,0.36,0.22,0.71,0.31 c0.23,0.06,0.44,0.12,0.66,0.17C5.49,9.7,5.72,9.78,5.96,9.87c0.47,0.19,0.82,0.45,1.04,0.78c0.23,0.33,0.34,0.76,0.34,1.29 C7.34,12.72,7.08,13.33,6.55,13.8z M15.33,14.36h-1.68V9.24l-1.23,3.3h-1.16l-1.23-3.3v5.12H8.44V6.64h1.95l1.5,3.81l1.49-3.81h1.95 V14.36z M21.18,13.8c-0.53,0.47-1.24,0.7-2.14,0.7c-0.52,0-0.97-0.06-1.36-0.17c-0.39-0.11-0.75-0.26-1.09-0.43v-1.84h0.16 c0.34,0.33,0.71,0.58,1.12,0.76c0.41,0.18,0.8,0.26,1.19,0.26c0.1,0,0.23-0.01,0.38-0.04c0.16-0.02,0.29-0.06,0.38-0.11 c0.12-0.06,0.22-0.14,0.3-0.25c0.08-0.1,0.12-0.24,0.12-0.42c0-0.19-0.07-0.35-0.2-0.47s-0.29-0.21-0.48-0.26 c-0.23-0.07-0.47-0.13-0.73-0.2c-0.26-0.06-0.51-0.14-0.73-0.23c-0.52-0.21-0.9-0.49-1.12-0.85c-0.23-0.36-0.34-0.8-0.34-1.34 c0-0.72,0.27-1.31,0.8-1.75c0.53-0.45,1.2-0.67,2-0.67c0.4,0,0.8,0.05,1.2,0.14c0.4,0.09,0.75,0.22,1.06,0.38v1.76h-0.15 c-0.25-0.25-0.56-0.45-0.92-0.62C20.27,7.99,19.9,7.9,19.52,7.9c-0.15,0-0.28,0.01-0.4,0.04C19,7.97,18.88,8.01,18.75,8.08 c-0.11,0.06-0.2,0.14-0.27,0.25c-0.08,0.11-0.12,0.23-0.12,0.37c0,0.2,0.06,0.35,0.18,0.47c0.12,0.12,0.36,0.22,0.71,0.31 c0.23,0.06,0.44,0.12,0.66,0.17c0.21,0.06,0.43,0.13,0.67,0.23c0.47,0.19,0.82,0.45,1.04,0.78c0.23,0.33,0.34,0.76,0.34,1.29 C21.97,12.72,21.7,13.33,21.18,13.8z"
                                        ></path>
                                    </g>
                                </svg>
                                <!--                                <span>PULSE</span>-->
                            </button>
                        </div>
                        <div class="col-lg-3 m-auto">
                            <button
                                class="btn p-4 buzz-out-on-hover"
                                style="color: rgb(103 107 95)"
                            >
                                <svg
                                    width="7em"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g
                                        id="SVGRepo_bgCarrier"
                                        stroke-width="0"
                                    ></g>
                                    <g
                                        id="SVGRepo_tracerCarrier"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    ></g>
                                    <g id="SVGRepo_iconCarrier">
                                        <path
                                            fill-rule="evenodd"
                                            clip-rule="evenodd"
                                            d="M3.75 5.25L3 6V18L3.75 18.75H20.25L21 18V6L20.25 5.25H3.75ZM4.5 7.6955V17.25H19.5V7.69525L11.9999 14.5136L4.5 7.6955ZM18.3099 6.75H5.68986L11.9999 12.4864L18.3099 6.75Z"
                                            fill="#000000"
                                        ></path>
                                    </g>
                                </svg>
                                <!--                                <span>Other</span>-->
                            </button>
                        </div>
                        <div class="col-lg-3 m-auto">
                            <button
                                data-bs-toggle="modal"
                                data-bs-target="#shareBySocialIcons"
                                class="btn p-4 buzz-out-on-hover"
                                style="color: rgb(103 107 95)"
                            >
                                <svg
                                    width="7em"
                                    viewBox="0 0 24 24"
                                    fill="none"
                                    xmlns="http://www.w3.org/2000/svg"
                                >
                                    <g
                                        id="SVGRepo_bgCarrier"
                                        stroke-width="0"
                                    ></g>
                                    <g
                                        id="SVGRepo_tracerCarrier"
                                        stroke-linecap="round"
                                        stroke-linejoin="round"
                                    ></g>
                                    <g id="SVGRepo_iconCarrier">
                                        <g
                                            id="Communication / Share_iOS_Export"
                                        >
                                            <path
                                                id="Vector"
                                                d="M9 6L12 3M12 3L15 6M12 3V13M7.00023 10C6.06835 10 5.60241 10 5.23486 10.1522C4.74481 10.3552 4.35523 10.7448 4.15224 11.2349C4 11.6024 4 12.0681 4 13V17.8C4 18.9201 4 19.4798 4.21799 19.9076C4.40973 20.2839 4.71547 20.5905 5.0918 20.7822C5.5192 21 6.07899 21 7.19691 21H16.8036C17.9215 21 18.4805 21 18.9079 20.7822C19.2842 20.5905 19.5905 20.2839 19.7822 19.9076C20 19.4802 20 18.921 20 17.8031V13C20 12.0681 19.9999 11.6024 19.8477 11.2349C19.6447 10.7448 19.2554 10.3552 18.7654 10.1522C18.3978 10 17.9319 10 17 10"
                                                stroke="#000000"
                                                stroke-width="2"
                                                stroke-linecap="round"
                                                stroke-linejoin="round"
                                            ></path>
                                        </g>
                                    </g>
                                </svg>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<style>
/* CSS animation for slide-in-top effect */
@keyframes slideInTop {
    0% {
        transform: translateY(-100%);
    }
    100% {
        transform: translateY(0);
    }
}

/* Apply animation to modal */
.slide-in-top {
    animation: slideInTop 0.5s forwards;
    padding-right: 0 !important;
}
</style>
<script>
import "@/assets/css/animation.css";
import ShareByQr from "@/Components/Links/Share/ShareByQr.vue";
import ShareBySocialIcons from "@/Components/Links/Share/ShareBySocialIcons.vue";
export default {
    props: ["appUrl", "user"],
    components: {
        ShareBySocialIcons,
        ShareByQr,
    },
};
</script>
